<template lang="pug">
  a.auth-popup-link(
    :class='classes'
    data-toggle='modal'
    v-text='linkText'
    @click='showAuthPopup'
  )
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'signIn'
    },
    classes: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: ''
    },
    returnPath: {
      type: String,
      default: ''
    }
  },

  computed: {
    linkText () {
      return this.text || this.$t(`account.user.${this.type}`)
    }
  },

  methods: {
    showAuthPopup () {
      this.$router.replace({ query: this.returnToQuery(), hash: '#authentication' })
    },

    returnToQuery () {
      const returnToPath = this.returnPath ? { 'return-to': this.returnPath } : {}
      return { ...returnToPath, ...this.$router.currentRoute.query }
    }
  }
}
</script>

<style lang='scss' scoped>
  .text {
    color: $white;
  }
</style>
